module.exports = __webpack_public_path__ + "static/media/09 Hur manga ganger - HMG (ft Lorentz_eq 05-29.6ab1830c.mp3";